import { InjectionToken } from '@angular/core';
import { SEAGatewayConfig } from './types';

export const SEA_GATEWAY_CONFIG = new InjectionToken<SEAGatewayConfig>(
	'SEAGatewayConfig'
);

export const CHARON_ID = new InjectionToken<string>('CharonId');
